import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { companionSettingStartupFlowDefinition } from "./CompanionSettingPage/CompanionSettingStartup";
import { myAccountPaymentStartupFlowDefinition } from "./Payments/PaymentStartup";
import { loyaltyProgramDetailStartupFlowDefinition } from "./LoyaltyProgramDetailPage/LoyaltyProgramDetailStartup";
import { personalInfoStartupFlowDefinition } from "./PersonalInformationPage/PersonalInformationStartup";
import { personalizeExperienceStartupFlowDefinition } from "./PersonalizeExperience/PersonalizeExperienceStartup";
import { settingsStartupFlowDefinition } from "./Settings/SettingsStartup";
import { MyAccountInitStepDeclaration } from "./Steps/MyAccountInitStep";
import { MyAccountTransition } from "./Transition/MyAccountTransition";

export const myAccountMainStartupFlow = new FlowDefinition("MyAccountFlow");

myAccountMainStartupFlow.addStep(MyAccountInitStepDeclaration);
myAccountMainStartupFlow.addStep(loyaltyProgramDetailStartupFlowDefinition);
myAccountMainStartupFlow.addStep(personalInfoStartupFlowDefinition);
myAccountMainStartupFlow.addStep(personalizeExperienceStartupFlowDefinition);
myAccountMainStartupFlow.addStep(companionSettingStartupFlowDefinition);
myAccountMainStartupFlow.addStep(settingsStartupFlowDefinition);
myAccountMainStartupFlow.addStep(myAccountPaymentStartupFlowDefinition);

// Add links between steps
myAccountMainStartupFlow.addLink("MyAccountInit_Step", "LoyaltyProgramDetailFlow");
myAccountMainStartupFlow.addLink("MyAccountInit_Step", "PersonalInformationFlow");
myAccountMainStartupFlow.addLink("MyAccountInit_Step", "PersonalizeExperienceFlow");
myAccountMainStartupFlow.addLink("MyAccountInit_Step", "CompanionSettingFlow");
myAccountMainStartupFlow.addLink("MyAccountInit_Step", "SettingsFlow");
myAccountMainStartupFlow.addLink("MyAccountInit_Step", "MyAccountPaymentsFlow");

myAccountMainStartupFlow.addLink("LoyaltyProgramDetailFlow", "MyAccountInit_Step");
myAccountMainStartupFlow.addLink("LoyaltyProgramDetailFlow", "PersonalInformationFlow");
myAccountMainStartupFlow.addLink("LoyaltyProgramDetailFlow", "PersonalizeExperienceFlow");
myAccountMainStartupFlow.addLink("LoyaltyProgramDetailFlow", "CompanionSettingFlow");
myAccountMainStartupFlow.addLink("LoyaltyProgramDetailFlow", "SettingsFlow");

myAccountMainStartupFlow.addLink("PersonalInformationFlow", "MyAccountInit_Step");
myAccountMainStartupFlow.addLink("PersonalInformationFlow", "LoyaltyProgramDetailFlow");
myAccountMainStartupFlow.addLink("PersonalInformationFlow", "PersonalizeExperienceFlow");
myAccountMainStartupFlow.addLink("PersonalInformationFlow", "CompanionSettingFlow");
myAccountMainStartupFlow.addLink("PersonalInformationFlow", "SettingsFlow");
myAccountMainStartupFlow.addLink("PersonalInformationFlow", "MyAccountPaymentsFlow");

myAccountMainStartupFlow.addLink("PersonalizeExperienceFlow", "MyAccountInit_Step");
myAccountMainStartupFlow.addLink("PersonalizeExperienceFlow", "LoyaltyProgramDetailFlow");
myAccountMainStartupFlow.addLink("PersonalizeExperienceFlow", "PersonalInformationFlow");
myAccountMainStartupFlow.addLink("PersonalizeExperienceFlow", "CompanionSettingFlow");
myAccountMainStartupFlow.addLink("PersonalizeExperienceFlow", "SettingsFlow");
myAccountMainStartupFlow.addLink("PersonalizeExperienceFlow", "MyAccountPaymentsFlow");

myAccountMainStartupFlow.addLink("CompanionSettingFlow", "MyAccountInit_Step");
myAccountMainStartupFlow.addLink("CompanionSettingFlow", "LoyaltyProgramDetailFlow");
myAccountMainStartupFlow.addLink("CompanionSettingFlow", "PersonalInformationFlow");
myAccountMainStartupFlow.addLink("CompanionSettingFlow", "PersonalizeExperienceFlow");
myAccountMainStartupFlow.addLink("CompanionSettingFlow", "SettingsFlow");
myAccountMainStartupFlow.addLink("CompanionSettingFlow", "MyAccountPaymentsFlow");

myAccountMainStartupFlow.addLink("SettingsFlow", "MyAccountInit_Step");
myAccountMainStartupFlow.addLink("SettingsFlow", "LoyaltyProgramDetailFlow");
myAccountMainStartupFlow.addLink("SettingsFlow", "PersonalInformationFlow");
myAccountMainStartupFlow.addLink("SettingsFlow", "PersonalizeExperienceFlow");
myAccountMainStartupFlow.addLink("SettingsFlow", "CompanionSettingFlow");
myAccountMainStartupFlow.addLink("SettingsFlow", "MyAccountPaymentsFlow");

myAccountMainStartupFlow.addLink("MyAccountPaymentsFlow", "MyAccountInit_Step");
myAccountMainStartupFlow.addLink("MyAccountPaymentsFlow", "PersonalInformationFlow");
myAccountMainStartupFlow.addLink("MyAccountPaymentsFlow", "PersonalizeExperienceFlow");
myAccountMainStartupFlow.addLink("MyAccountPaymentsFlow", "SettingsFlow");
myAccountMainStartupFlow.addLink("MyAccountPaymentsFlow", "CompanionSettingFlow");

myAccountMainStartupFlow.addTransition(MyAccountTransition, "MyAccountInit_Step")
myAccountMainStartupFlow.addTransition(MyAccountTransition, "LoyaltyProgramDetailFlow")
myAccountMainStartupFlow.addTransition(MyAccountTransition, "PersonalInformationFlow")
myAccountMainStartupFlow.addTransition(MyAccountTransition, "PersonalizeExperienceFlow")
myAccountMainStartupFlow.addTransition(MyAccountTransition, "CompanionSettingFlow")
myAccountMainStartupFlow.addTransition(MyAccountTransition, "SettingsFlow")
myAccountMainStartupFlow.addTransition(MyAccountTransition, "MyAccountPaymentsFlow")

myAccountMainStartupFlow.setStartStep("MyAccountInit_Step");

export const myAccountStepDefinition = new StepDefinition({
    stepName: "MyAccountFlow",
    stepFlow: myAccountMainStartupFlow,
    contextIsolation: false
})

